var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeOfUsePlansWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66667C5.40835 1.66667 1.66669 5.40834 1.66669 10C1.66669 14.5917 5.40835 18.3333 10 18.3333C14.5917 18.3333 18.3334 14.5917 18.3334 10C18.3334 5.40834 14.5917 1.66667 10 1.66667ZM13.625 12.975C13.5084 13.175 13.3 13.2833 13.0834 13.2833C12.975 13.2833 12.8667 13.2583 12.7667 13.1917L10.1834 11.65C9.54169 11.2667 9.06669 10.425 9.06669 9.68334V6.26667C9.06669 5.925 9.35002 5.64167 9.69169 5.64167C10.0334 5.64167 10.3167 5.925 10.3167 6.26667V9.68334C10.3167 9.98334 10.5667 10.425 10.825 10.575L13.4084 12.1167C13.7084 12.2917 13.8084 12.675 13.625 12.975Z",
    fill: "#F5F6FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOfUsePlansWhiteIcon);
export default __webpack_public_path__ + "static/media/time-of-use-plans-white-icon.a4089f8783c926c9e005c008ce1d3382.svg";
export { ForwardRef as ReactComponent };